define(function (require) {
	const tpl = require('../templates/t_lov_enforced_setup.hbs');
	const ViewManager = require('civicsUtils/view_manager');
	const UnifiedMfaSetupModal = require('./v_lov_unified_mfa_setup');
	const user_data_utils = require('civicsUtils/user_data_utils');
	const factorUtils = require('civicsViews/core/two_factor_authentication/2fa_utility');

	return Marionette.LayoutView.extend({
		className: 'v-lov-enforced-setup-modal',
		template: tpl,
		ui: {
			closeButton: '.bbm-btn-close',
			getStartedButton: '.get-started-modal',
			skipButton: '.skip-setup-modal'
		},
		regions: {

		},
		events: {
			'click @ui.closeButton': 'closeModal',
			'click @ui.getStartedButton': 'showNextModal',
		},
		initialize: function (options) {
			this.options = options;
			this.config = options.config?.config || options.config || {};
			this.globalConfig = ViewManager.globalConfig().toJSON();
			this.modalRegion = options.modalRegion;
			this.twoFAUtil = new factorUtils({ modalRegion: this.modalRegion });
		},
		onShow: function () {
		},
		showNextModal: function (e) {
			// Check for active process or a wizard project before MFA setup 
			const activeProcess = App.sessionStorage.get('PROCESSMANAGER', 'ACTIVE_PROCESS') || null;
			const wizardProject = App.sessionStorage.get('CIVICS', 'WIZARD') || null;
			
			// Create unified modal with all steps
			const unifiedModal = new UnifiedMfaSetupModal({
				config: this.config,
				modalRegion: this.modalRegion,
				activeProcess: activeProcess,
				wizardProject: wizardProject
			});
			
			this.twoFAUtil.showModalView(unifiedModal);
		},
		closeModal: function (e) {
			ViewManager.loading(true);
			if (e) {
				e.stopPropagation();
				e.preventDefault();
			}
			
			// Hide modal and redirect immediately
			this.modalRegion.hideModal();
			this.$el.hide(); // Hide the view immediately
			App.localStorage.remove('CIVICS', 'REQUIRES_MFA_ENROLLMENT');
			App.sessionStorage.remove('PROCESSMANAGER');
			window.location.href = '/c/portal/logout';
		},
		templateHelpers: function () {
			let methodType = factorUtils().getAuthenticationStrings();
			return {
				title: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.LETS_SECURE_YOUR_ACCOUNT_HEADER'),
				bodyText: i18n.t('CIVICS.LOGIN.ENFORCED_MFA.LETS_SECURE_YOUR_ACCOUNT_INSTRUCTIONAL_MSG', {methodTypeTitle: methodType.methodTypeTitle, methodTypeAbbrev: methodType.methodTypeAbbrev}),
			};
		}
	});
});